import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=59ead8ba&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=59ead8ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ead8ba",
  null
  
)

export default component.exports